import { compose, mapProps } from 'recompose';
import { graphql } from 'react-apollo';

import { getFormattedName } from '../../../selectors/formatName/selector';
import { getCurrentUser } from '../../../graphql/operations';

export const FormatName = props => props.formattedName;

export const FormatNameHOC = compose(
  graphql(getCurrentUser, { name: 'getCurrentUser' }),
  mapProps(props => ({
    formattedName: getFormattedName(props)
  }))
);

export default FormatNameHOC(FormatName);
